import React from 'react';
import { getSubtaskStatusBreakdown } from '../../../utils/taskUtils';
import Tooltip from '../../../../../ui/components/Tooltip/Tooltip';
import './ProgressTooltip.css';

const STATUS_LABELS = {
  complete: 'Complete',
  wont_do: "Won't do",
  wip: 'Work in progress',
  waiting: 'Waiting',
  incomplete: 'Incomplete',
  blocked: 'Blocked'
};

const STATUS_COLORS = {
  complete: '#4D94DB',
  wont_do: '#475569',
  wip: '#fde68a',
  waiting: '#e9d5ff',
  incomplete: '#fff',
  blocked: '#ffe8e8'
};

function ProgressTooltip({ visible, anchorRef, task, tasks, subtaskStats, onMouseEnter, onMouseLeave, summaryLabel = 'Subtask status' }) {
  if (!task || !subtaskStats || subtaskStats.total === 0) return null;

  const statusBreakdown = getSubtaskStatusBreakdown(task, tasks || []);
  const percentage = subtaskStats.total > 0 ? subtaskStats.weightedProgress / subtaskStats.total : 0;
  const percentageText = Math.round(percentage * 100);
  const hasNoCompletedTasks = percentage === 0;
  const statusesInBreakdown = new Set(statusBreakdown.map(({ status }) => status));
  const hasIncompleteAndBlocked = statusesInBreakdown.has('incomplete') && statusesInBreakdown.has('blocked');
  const showEmptyMessage = hasNoCompletedTasks && !hasIncompleteAndBlocked;

  const emptyMessage =
    summaryLabel === 'File task status'
      ? 'No completed tasks in list'
      : 'No completed subtasks';

  return (
    <Tooltip
      visible={visible}
      anchorRef={anchorRef}
      placement="top"
      className="progress-tooltip"
      portal
    >
      <div
        className={`progress-tooltip-inner${showEmptyMessage ? ' progress-tooltip-inner-empty' : ''}`}
        data-progress-tooltip
        onMouseEnter={onMouseEnter}
        onMouseLeave={onMouseLeave}
      >
        {showEmptyMessage ? (
          <>
            <div className="progress-tooltip-summary progress-tooltip-summary-title">{emptyMessage}</div>
            <span className="progress-tooltip-empty-subtitle">
              {summaryLabel === 'File task status' ? 'This indicates list status' : 'Parent task indicates subtask status'}
            </span>
          </>
        ) : (
          <>
            <div className="progress-tooltip-summary">
              {summaryLabel}: {percentageText}%
            </div>
            <ul className="progress-tooltip-breakdown">
              {statusBreakdown.map(({ status, count, percentage: pct }) => (
                <li key={status} className="progress-tooltip-row">
                  <span
                    className="progress-tooltip-swatch"
                    style={{ backgroundColor: STATUS_COLORS[status] || '#767676' }}
                  />
                  <span className="progress-tooltip-label">{STATUS_LABELS[status] || status}</span>
                  <span className="progress-tooltip-count">
                    {count} {count === 1 ? 'task' : 'tasks'}
                  </span>
                </li>
              ))}
            </ul>
          </>
        )}
      </div>
    </Tooltip>
  );
}

export default ProgressTooltip;
